<template>
  <div class="xcard">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 class="text-primary text-center mt-0 pt-0 mb-0">
      Filtro de personas por Rol
    </h3>

    <v-row>
      <v-col>
        <v-combobox
          v-model="rol"
          :items="roles"
          label="* Seleccione un cargo"
          hide-details
          outlined
          dense
          return-object
          item-text="nombre"
        ></v-combobox>
      </v-col>
      <v-col>
        <p class="pt-3"><b>Sede: </b> {{ $store.state.CARGO.sede.nombre }}</p>
      </v-col>
    </v-row>
    <template>
      <v-data-table
        :loading="loading"
        :loader-height="4"
        :headers="headers"
        :items="personas"
        :items-per-page="80"
        class="elevation-1"
      ></v-data-table>
    </template>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        rol: null,
        roles: [],
        loading: false,
        headers: [
          { text: 'Documento', value: 'num_doc' },
          { text: 'Nombre', value: 'nombre' },
          { text: 'Apellido 1', value: 'primer_apellido' },
          { text: 'Apellido 2', value: 'segundo_apellido' },
          { text: 'Cargo', value: 'cargo' },
        ],
        personas: [],
      };
    },
    watch: {
      rol: function() {
        if (!this.rol) return;
        this.listarpersonas();
      },
      '$store.state.CARGO': function(){
        if (!this.rol) return;
        this.listarpersonas();
      }
    },
    components: {},
    methods: {
      async getCargos() {
        let vue = this;
        let sq = 'query { getCargos {   id   nombre }}';
        let sql = gql`
          ${sq}
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            let dat = data.data.getCargos;
            vue.roles = dat;
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      listarpersonas() {
        this.personas = [];
        this.loading = true;
        const vue = this;
        let idsede = this.$store.state.CARGO.sede.id;
        let url1 = `${process.env.VUE_APP_API_REST}/api/v1/user/cargos?sede_id=${idsede}&cargos=${this.rol.id}`;
        const promise1 = xaxios.get(url1);

        Promise.all([promise1])
          .then(function(values) {
            let data1 = values[0];
            if (data1.data) {
              vue.personas = data1.data.data;
            }
            window.console.log('>>', data1.data.data);
            vue.loading = false;
          })
          .catch((e) => {
            vue.$emit('dataloaded');
            window.console.error(e);
            vue.loading = false;
          });
      },
    },
    mounted() {
      this.getCargos();
    },
  };
</script>
